import { Row, Col } from "antd";
import { Fade } from "react-awesome-reveal";
import { withTranslation, TFunction } from "react-i18next";
import { Button } from "../../common/Button";
import {
  PricingSection,
  PricingWrapper,
  PricingCard,
  PricingHeader,
  PricingTitle,
  PricingPrice,
  PricingPeriod,
  FeatureList,
  FeatureItem,
  PopularBadge,
} from "./styles";

interface PricingProps {
  title: string;
  content: string;
  plans: Array<{
    name: string;
    price: string;
    period: string;
    features: string[];
    popular?: boolean;
  }>;
  id: string;
  t: TFunction;
}

const Pricing = ({ title, content, plans, id, t }: PricingProps) => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <PricingSection id={id}>
      <Fade direction="up" triggerOnce>
        <Row justify="center">
          <Col span={24} style={{ textAlign: "center", marginBottom: "4rem" }}>
            <h6>{t(title)}</h6>
            <p>{t(content)}</p>
          </Col>
        </Row>
        <PricingWrapper>
          <Row gutter={[32, 32]} justify="center">
            {plans.map((plan, index) => (
              <Col key={index} lg={8} md={12} sm={24} xs={24}>
                <PricingCard popular={plan.popular}>
                  {plan.popular && <PopularBadge>Most Popular</PopularBadge>}
                  <PricingHeader>
                    <PricingTitle>{plan.name}</PricingTitle>
                    <div>
                      <PricingPrice>{plan.price}</PricingPrice>
                      <PricingPeriod>{plan.period}</PricingPeriod>
                    </div>
                  </PricingHeader>
                  <FeatureList>
                    {plan.features.map((feature, idx) => (
                      <FeatureItem key={idx}>{feature}</FeatureItem>
                    ))}
                  </FeatureList>
                  <Button onClick={() => scrollTo("contact")}>
                    {plan.name === "Enterprise" ? "Contact Sales" : "Get Started"}
                  </Button>
                </PricingCard>
              </Col>
            ))}
          </Row>
        </PricingWrapper>
      </Fade>
    </PricingSection>
  );
};

export default withTranslation()(Pricing);